import { sva } from '@allenai/varnish-panda-runtime/css';

import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const chipRecipe = sva({
    slots: ['root', 'text', 'removeButton'],
    base: {
        root: {
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            border: '[1px solid transparent]',

            _disabled: {
                cursor: 'not-allowed',
                colorPalette: 'elements.disabled',
                // color: 'text.primary',
                // backgroundColor: 'gray.20',
                // borderColor: 'gray.40',
            },

            // link chips
            // TODO: Is this the best way? hasHref (internal)variant overkill ?
            '&[data-href]': {
                cursor: 'pointer',
                textDecoration: 'underline',
            },

            // TODO: deal with selected / hover / disabled
            // _selected { ... }
            //
            // '&[aria-selected=false]': {
            //     _hover: {
            //         _notDisabled: {
            //             borderColor: 'green.40',
            //         },
            //     },
            // },
            // '&[data-selected]': {
            //     _hover: {
            //         _notDisabled: {
            //             borderColor: 'green.40',
            //         },
            //     },
            //     borderColor: 'green.100',
            // },
            //
            // _hover: {
            //     _selected: {
            //         //
            //     },
            // },
        },
        text: {},
        removeButton: {
            display: 'inline-flex',
            alignItems: 'center',
            background: '[none]',

            border: 'none',
            cursor: 'pointer',
            padding: '0',

            // Default to the same as text color
            // `default` | `faded` variants override
            color: '[currentColor]',

            // default Icon size:
            fontSize: '[16px]',

            _disabled: {
                cursor: 'not-allowed',
            },
        },
    },
    variants: {
        variant: {
            contained: {
                root: {
                    color: 'colorPalette.contrast',
                    backgroundColor: 'colorPalette.fill',
                },
            },
            outlined: {
                root: {
                    borderColor: 'colorPalette.stroke',
                    color: 'colorPalette.fill',
                },
            },
        },
        shape: {
            rounded: {
                root: {
                    borderRadius: 'full',
                },
            },
            box: {
                root: {
                    borderRadius: '[4px]',
                },
            },
        },
        color: {
            default: {
                root: {
                    colorPalette: 'elements.default',
                },
            },
            faded: {
                root: {
                    colorPalette: 'elements.faded',
                },
            },
            primary: {
                root: {
                    colorPalette: 'elements.primary',
                },
            },
            secondary: {
                root: {
                    colorPalette: 'elements.secondary',
                },
            },
            tertiary: {
                root: {
                    colorPalette: 'elements.tertiary',
                },
            },
        },

        size: {
            xsmall: {
                root: {
                    height: '[24px]',
                    padding: '[3px 5px]', // padding -= 1 because of border
                    fontSize: '[12px]',
                    gap: '[4px]',
                },
                text: {},
            },
            small: {
                root: {
                    height: '[32px]',
                    padding: '[3px 7px]', // padding -= 1 because of border
                    fontSize: '[14px]',
                    gap: '[6px]',
                },
                text: {},
            },
            medium: {
                root: {
                    height: '[36px]',
                    padding: '[7px 15px]', // padding -= 1 because of border
                    fontSize: 'sm',
                    gap: '[6px]',

                    // has icon paddingLeft smaller
                },
                text: {},
            },
            large: {
                root: {
                    height: '[48px]',
                    padding: '[11px 19px]', // padding -= 1 because of border
                    fontSize: 'md',
                    gap: '[8px]',
                },
                text: {},
                removeButton: {
                    fontSize: '[32px]',
                },
            },
        },
        // this might be needed
        hasIcon: {
            true: {},
        },
    },
    compoundVariants: [
        {
            color: ['default', 'faded'],
            css: {
                removeButton: {
                    // disabled will get the text color still
                    _notDisabled: {
                        color: 'elements.secondary.fill',
                    },
                },
            },
        },
    ],
    defaultVariants: {
        color: 'default',
        size: 'medium',
        variant: 'outlined',
        shape: 'rounded',
    },
});

type ChipRecipeProps = RecipeVariantProps<typeof chipRecipe>;

export { chipRecipe, ChipRecipeProps as default };
export type { ChipRecipeProps };
